<template>
    <div class="edit_product_name" :data-indicador="indicador">
        <h4 class="product_item_name with_logo" :data-indicador="indicador" v-if="!editActive && validName" @click.prevent="activeEdit()">
            <span class="logo_perfil">
                <i class="fas fa-info-circle"></i>
            </span>
            {{ product.product_name }}
        </h4>
        <div class="content-editor" v-else>
            <textarea
                v-model="product.product_name"
                class="widget_edit_product_name"
                :placeholder="lang.bsen_add_name_ph"
                maxlength="50"
                ref="editproduct_name"
                @keypress="noEnter"
                @change="saveProductName()"
                @focusout="inactiveEdit"
            ></textarea>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
export default {
    components: {
        VueEditor,
    },
    props: ['indicador', 'product'],
    data(){
        return {
            loadSave: false,
            editActive: false,
            apis: null,
            lang: {
                bsen_add_name_ph: '',
                bs_error: '',
                bs_could_not_save: '',
            },
        };
    },
    created(){
        let t = this;
        t.lang = t.$store.getters['ModApps/Marketea/lang'];
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bStore;
    },
    methods: {
        activeEdit(){
            let t = this;
            t.editActive = true;
            setTimeout(() => {
                if(t.$refs.editproduct_name){
                    t.$refs.editproduct_name.focus();
                }
            }, 200);
        },
        inactiveEdit(){this.editActive = false;},
        noEnter(e){
            let t = this;
            var code = (e.which) ? e.which : e.keyCode;
            if(code == 13){
                e.preventDefault();
                t.saveProductName()
            }
        },
        saveProductName(){
            let t= this;
            t.inactiveEdit()
            let urlService = t.apis.set(3)// setProduct
            if(!t.loadSave){
                t.loadSave = true;
                // @ts-ignore
                window.master.post(urlService, t.product)
                .then((response) => {
                    console.log(urlService, t.product, response.data);
                    t.loadSave = false;
                })
                .catch((error) => {
                    console.log(error);
                    t.loadSave = false;
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: t.lang.bs_error,
                        text: t.lang.bs_could_not_save,
                    });
                });
            }
        },
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            langGetter: "lang",
        }),
        validName: function(){
            let t = this;
            return (t.product.product_name && t.product.product_name.trim().length>0);
        },
    },
    watch: {
        langGetter() { this.lang = this.$store.getters['ModApps/Marketea/lang']; },
    },
}
</script>
<style lang="scss" scoped>
    .edit_product_name {
        .product_item_name{
            border: 1px dashed transparent;
            &:hover{
                border: 2px dashed #edd340;
                border-radius: 4px;
            }
        }
        textarea.widget_edit_product_name{
            width: 100%;
            height: 40px;
            font-size: 1.5rem;
            font-weight: bold;
            color: #000;
            font-family: Arial, Helvetica, sans-serif;
            text-align: left;
            padding: 5px;
            resize: none;
            overflow: hidden;
            box-shadow: none;
            outline: none;
            border: 1px solid #fafafa;
            &:focus {
                border-color: light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
            }
            &::placeholder {
                color: #c4c4c4;
                font-weight: 400;
            }
        }
    }
</style>
